export default __webpack_public_path__ + "static/media/whatsapp_logo.f3d91ae0.svg";